import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { RateLookUp } from './rate-lookup-model';

export class RateReasonsWithComment extends Model {
  @Expose()
  @Type(() => RateLookUp)
  InternetQualityAndSound: RateLookUp;
  @Expose()
  @Type(() => RateLookUp)
  QuietnessDuringTheCall: RateLookUp;
  @Expose()
  @Type(() => RateLookUp)
  TeacherInteractionWellWithStudent: RateLookUp;
  @Expose()
  @Type(() => RateLookUp)
  ErrorCorrection: RateLookUp;
  @Expose()
  @Type(() => RateLookUp)
  AccuracyOfEducationalSessionLogData: RateLookUp;
  @Expose()
  @Type(() => RateLookUp)
  ForTheVideoSession: RateLookUp;
  @Expose()
  @Type(() => RateLookUp)
  teacherWillingToExplainApp: RateLookUp;
}
